import { watch } from 'vue';
import { store } from '@/common/root';
import socketio from '@/common/utils/socketio.connection';
import type { ModePreset } from '@/common/store/pinia/appMode';

type OagwHeaders = NonNullable<
  Extract<NonNullable<AppOptions['providers']>, { httpAdapter: import('axios').AxiosInstance }>
>['oagwHeaders'];

const RECONNECT_DEBOUNCE_MS = 500;

export function setupOagwWebSocketRecovery({
  oagwHeaders,
  setAppModeSettings
}: {
  oagwHeaders: OagwHeaders;
  setAppModeSettings: (settings: DeepPartial<ModePreset>) => void;
}): void {
  if (!oagwHeaders) return;

  let reconnectTimer: ReturnType<typeof setTimeout> | null = null;

  watch(() => oagwHeaders['x-oagw-route'].value, (newRoute, oldRoute) => {
    if (!newRoute || newRoute === oldRoute) return;
    const gateway = {
      'x-oagw-route': newRoute,
      'x-oagw-tenant': oagwHeaders['x-oagw-tenant'].value,
    };
    setAppModeSettings({
      websocket: {
        queryParams: gateway,
        headers: gateway,
      },
    });
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
    }
    reconnectTimer = setTimeout(() => {
      reconnectTimer = null;
      store.dispatch('socket/DISCONNECT');
      store.dispatch('socket/CONNECT');
    }, RECONNECT_DEBOUNCE_MS);
  });

  let wsRecoveryInFlight = false;
  socketio.on('connect_error', () => {
    if (wsRecoveryInFlight) return;
    wsRecoveryInFlight = true;
    oagwHeaders.triggerRecovery()
      .catch(() => { })
      .finally(() => {
        wsRecoveryInFlight = false;
      });
  });
}
